import {
  ADD_SALES_ORDER,
  DELETE_SALES_ORDER,
  SALES_ORDERS,
  ADD_SALES_ORDER_ERROR,
  SALES_ORDER_DETAILS,
  UPDATE_SALES_ORDER,
  SALES_ORDER_REPORTS,
} from "../../types/SalesOrderType";
import axios from "axios";
import { toast } from "react-toastify";

const addSalesOrderAction = (data) => {
  return {
    type: ADD_SALES_ORDER,
    payload: data,
  };
};

const getSalesOrdersAction = (data) => {
  return {
    type: SALES_ORDERS,
    payload: data,
  };
};

const getSalesOrderDetailsAction = (data) => {
  return {
    type: SALES_ORDER_DETAILS,
    payload: data,
  };
};

const updateSalesOrderAction = (data) => {
  return {
    type: UPDATE_SALES_ORDER,
    payload: data,
  };
};

const deleteSalesOrderAction = (id) => {
  return {
    type: DELETE_SALES_ORDER,
    payload: id,
  };
};

const getSalesOrderReportsAction = (data) => {
  return {
    type: SALES_ORDER_REPORTS,
    payload: data,
  };
};

// Create Sales Order
export const createSalesOrder = (values) => {
  return async (dispatch) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `sales-order/`,
        data: {
          ...values,
        },
      });

      if (data.success) {
        dispatch(addSalesOrderAction(data.order));
        toast.success("Sales Order Created Successfully");
        return {
          orderId: data.order.id,
          message: "success",
        };
      }
    } catch (error) {
      toast.error(error.response?.data?.error || error.message);
      console.log(error.message);
      return {
        message: "error",
      };
    }
  };
};

// Get All Sales Orders
export const getSalesOrders = (filters = {}) => {
  return async (dispatch) => {
    try {
      const { data } = await axios({
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `sales-order/`,
        params: filters,
      });

      if (data.success) {
        dispatch(getSalesOrdersAction(data));
        return {
          orders: data.orders,
          pagination: data.pagination,
          message: "success",
        };
      }
    } catch (error) {
      toast.error(error.response?.data?.error || error.message);
      console.log(error.message);
      return {
        message: "error",
      };
    }
  };
};

// Get Sales Order by ID
export const getSalesOrderById = (id) => {
  return async (dispatch) => {
    try {
      const { data } = await axios({
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `sales-order/${id}`,
      });

      if (data.success) {
        dispatch(getSalesOrderDetailsAction(data));
        return {
          order: data.order,
          message: "success",
        };
      }
    } catch (error) {
      toast.error(error.response?.data?.error || error.message);
      console.log(error.message);
      return {
        message: "error",
      };
    }
  };
};

// Update Sales Order
export const updateSalesOrder = (id, values) => {
  return async (dispatch) => {
    try {
      const { data } = await axios({
        method: "put",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `sales-order/${id}`,
        data: {
          ...values,
        },
      });

      if (data.success) {
        dispatch(updateSalesOrderAction(data.order));
        toast.success("Sales Order Updated Successfully");
        return {
          order: data.order,
          message: "success",
        };
      }
    } catch (error) {
      toast.error(error.response?.data?.error || error.message);
      console.log(error.message);
      return {
        message: "error",
      };
    }
  };
};

// Delete Sales Order
export const deleteSalesOrder = (id) => {
  return async (dispatch) => {
    try {
      const { data } = await axios({
        method: "delete",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `sales-order/${id}`,
      });

      if (data.success) {
        dispatch(deleteSalesOrderAction(id));
        toast.success("Sales Order Deleted Successfully");
        return {
          message: "success",
        };
      }
    } catch (error) {
      toast.error(error.response?.data?.error || error.message);
      console.log(error.message);
      return {
        message: "error",
      };
    }
  };
};

// Update Order Item Fulfillment (and optionally sale_price).
// payload: { item_id, fulfilled_quantity?, sale_price? } for single item, or { items: [{ item_id, fulfilled_quantity?, sale_price? }, ...] } for batch.
export const updateOrderItemFulfillment = (orderId, payload) => {
  return async (dispatch) => {
    try {
      const { data } = await axios({
        method: "put",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `sales-order/${orderId}/fulfillment`,
        data: payload,
      });

      if (data.success) {
        toast.success("Fulfillment Updated Successfully");
        dispatch(getSalesOrderById(orderId));
        return { message: "success" };
      }
    } catch (error) {
      toast.error(error.response?.data?.error || error.message);
      console.log(error.message);
      return { message: "error" };
    }
  };
};

// Get Sales Order Reports
export const getSalesOrderReports = (reportType, filters = {}) => {
  return async (dispatch) => {
    try {
      const { data } = await axios({
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `sales-order/reports/${reportType}`,
        params: filters,
      });

      if (data.success) {
        dispatch(getSalesOrderReportsAction({ reportType, data }));
        return {
          data: data,
          message: "success",
        };
      }
    } catch (error) {
      toast.error(error.response?.data?.error || error.message);
      console.log(error.message);
      return {
        message: "error",
      };
    }
  };
};
